import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface ButtonProps {
  id?: string;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const ButtonIcon = React.forwardRef<HTMLButtonElement, ButtonProps>(
  function (
    { id, disabled = false, className, onClick = () => {}, children },
    ref
  ) {
    const classNames = twMerge(
      'flex flex-row justify-center font-bold py-2 px-2 rounded-full box-border text-sm font-normal',
      disabled ? 'cursor-not-allowed bg-[#9EABCA]' : 'hover:bg-[#231D32]',
      className
    );

    const handleClick = disabled ? () => {} : onClick;

    return (
      <button ref={ref} id={id} className={classNames} onClick={handleClick}>
        {children}
      </button>
    );
  }
);

export default ButtonIcon;
